export default __webpack_public_path__ + "static/media/kwid-gallery-4.79276bc0.jpg";